var _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuProposalsManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "contract_1_",
    "data-name": "contract (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57645",
    "data-name": "Group 57645",
    transform: "translate(9.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57644",
    "data-name": "Group 57644"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10311",
    "data-name": "Path 10311",
    d: "M302.044,2.732a1.4,1.4,0,0,0-.412-.994L300.306.412a1.438,1.438,0,0,0-1-.412h-.081V2.813h2.822V2.732Z",
    transform: "translate(-299.222)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_57647",
    "data-name": "Group 57647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57646",
    "data-name": "Group 57646"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10312",
    "data-name": "Path 10312",
    d: "M8.561,9.673a1.881,1.881,0,0,1,.45-.731L12.185,5.78V3.75H8.891a.456.456,0,0,1-.454-.469V0H1.406A1.408,1.408,0,0,0,0,1.406V14.594A1.408,1.408,0,0,0,1.406,16h9.36a1.419,1.419,0,0,0,1.419-1.406V11.1l-.515.5a1.864,1.864,0,0,1-.729.45l-1.49.5-.227.012a1.172,1.172,0,0,1-1.111-1.544ZM2.344,8.437H7.016a.469.469,0,0,1,0,.938H2.344a.469.469,0,0,1,0-.938ZM1.875,7.031a.468.468,0,0,1,.469-.469H7.016a.469.469,0,1,1,0,.937H2.344A.468.468,0,0,1,1.875,7.031Zm0,3.75a.468.468,0,0,1,.469-.469H7.016a.469.469,0,0,1,0,.938H2.344A.468.468,0,0,1,1.875,10.781Zm7.016,2.344a.469.469,0,1,1,0,.938H6.079a.469.469,0,1,1,0-.937Zm-6.547-7.5a.469.469,0,1,1,0-.937H8.891a.469.469,0,1,1,0,.938Z",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_57649",
    "data-name": "Group 57649",
    transform: "translate(8.989 10.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57648",
    "data-name": "Group 57648"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10313",
    "data-name": "Path 10313",
    d: "M288.083,322.808l-.408,1.223a.234.234,0,0,0,.3.3l1.223-.408Z",
    transform: "translate(-287.663 -322.808)",
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_57651",
    "data-name": "Group 57651",
    transform: "translate(9.963 6.228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57650",
    "data-name": "Group 57650"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10314",
    "data-name": "Path 10314",
    d: "M321.907,199.307l-3.087,3.087,1.331,1.331,3.087-3.087Z",
    transform: "translate(-318.82 -199.307)",
    fill: "#fff"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_57653",
    "data-name": "Group 57653",
    transform: "translate(13.713 4.623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57652",
    "data-name": "Group 57652"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10315",
    "data-name": "Path 10315",
    d: "M440.83,148.209a.979.979,0,0,0-1.33,0l-.681.681,1.331,1.331.681-.681A.944.944,0,0,0,440.83,148.209Z",
    transform: "translate(-438.819 -147.949)",
    fill: "#fff"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_57656",
    "data-name": "Group 57656",
    transform: "translate(15.725 6.206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57655",
    "data-name": "Group 57655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57654",
    "data-name": "Group 57654"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10316",
    "data-name": "Path 10316",
    d: "M503.215,198.811h0l0,0Z",
    transform: "translate(-503.215 -198.802)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10317",
    "data-name": "Path 10317",
    d: "M503.3,198.679l0,0Z",
    transform: "translate(-503.3 -198.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10318",
    "data-name": "Path 10318",
    d: "M503.436,198.6Z",
    transform: "translate(-503.429 -198.602)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuProposalsManagement);
export default __webpack_public_path__ + "static/media/icon-menu-proposals-management.1970349013ffaa69a076118ea9525282.svg";
export { ForwardRef as ReactComponent };